import { Box } from '@mui/material';
import React from 'react';

import useRole from 'hooks/useRole';

import EditArtworkAudio from '../EditArtworkAudio';
import EditArtworkCollectorComment from '../EditArtworkCollectorComment';
import EditArtworkEdition from '../EditArtworkEdition';
import EditArtworkImages from '../EditArtworkImages';
import EditArtworkInfo from '../EditArtworkInfo';

const EditArtworkDetailBlock = ({ artworkFormState, artwork, isArtist }) => {
  const { isCollector } = useRole();

  return (
    <Box>
      <EditArtworkEdition
        artworkFormState={artworkFormState}
        artwork={artwork}
      />
      <EditArtworkImages
        artworkFormState={artworkFormState}
        artwork={artwork}
      />

      {isCollector && <EditArtworkCollectorComment artworkFormState={artworkFormState} />}
      <EditArtworkInfo
        artworkFormState={artworkFormState}
        artwork={artwork}
      />
      {isArtist && (
        <EditArtworkAudio
          artworkFormState={artworkFormState}
          isArtist={isArtist}
        />
      )}
    </Box>
  );
};

export default EditArtworkDetailBlock;
